import React from "react";

import DataAnswersList from "../../../templates/student/DataAnswersList";
import {
  Context,
  fetchTeachingMaterials,
  fetchAnswersStatistic,
  fetchActionList,
  fetchOnePagePortfolioAnswers,
  updateComment,
  deleteComment,
} from "../../../studentStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";

const excludeKind = "core_vol0";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [
    currentTeachingMaterialId,
    setCurrentTeachingMaterialId,
  ] = React.useState(0);

  React.useEffect(() => {
    dispatch(fetchTeachingMaterials());
    dispatch(fetchActionList());
  }, [dispatch]);

  const handleChangePage = (id: number) => {
    setCurrentTeachingMaterialId(id);
    dispatch(fetchAnswersStatistic(id));
    dispatch(peep(fetchOnePagePortfolioAnswers(id)));
  };

  const handleComment = React.useCallback(
    (answerId: number, content: string, commentId?: number) => {
      if (!commentId) return;
      dispatch(peep(updateComment(answerId, content, commentId)));
    },
    [dispatch, peep],
  );

  const handleDeleteComment = React.useCallback(
    (answerId: number, commentId: number) => {
      dispatch(peep(deleteComment(answerId, commentId)));
    },
    [dispatch, peep],
  );

  const filterdTeachingMaterials = React.useMemo(
    () => state.teaching_materials.filter(tm => tm.kind !== excludeKind),
    [state.teaching_materials],
  );

  return (
    <DataAnswersList
      teaching_materials={filterdTeachingMaterials}
      listLessons={state.answers_statistic.teaching_material.lessons}
      calling={calling}
      currentStudentId={state.student?.id ?? 0}
      teachingMaterialId={currentTeachingMaterialId}
      portfolio={state.onePagePortfolioAnswers}
      actionList={state.action_list}
      onChangeTeachingMaterial={handleChangePage}
      handleComment={handleComment}
      handleDeleteComment={handleDeleteComment}
    />
  );
};
